import Label from "components/Label/Label";
import React, { FC, Fragment, useState, useEffect, useRef } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'
export interface PageCreateStoryProps {
  className?: string;
}
const PageCreateStory: FC<PageCreateStoryProps> = ({
  className = "",
}) => {
  const options = {
    title: {
      text: 'Total Gift Card Value USD$500',
      align: 'left'
    },
    series: [{
      type: 'pie',
      data: [{
        y: 1,
        name: "Used Gift Value",
        color: "#000000"
      }, {
        y: 7,
        name: "Balance Gift Value",
        color: "#f15e75"
      }]
    }]
  }
  const PagePeferralProgram = () => {
    return (
      <div className="right-user-details-card">
        <div className="card h-full">
          <div className="flex justify-between"><h4>Add A Trip Story</h4></div>
          <div className="w-full">
            <div className="title-group">
              <label>SHARE YOUR PHOTOS</label>
              <p>We recommend uploading pictures of famous landmarks if you can.</p>
              <div className="photo-upload">
                <div className="file-upload">
                  <input type="file" />
                  <svg width="50" height="41" viewBox="0 0 50 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.6324 23.5832C31.6324 27.2485 28.6653 30.2156 25 30.2156C21.3347 30.2156 18.3676 27.2485 18.3676 23.5832C18.3676 19.9179 21.3347 16.9507 25 16.9507C28.6653 16.9507 31.6324 19.9179 31.6324 23.5832ZM45.2053 6.96099C47.8542 6.96099 50 9.10678 50 11.7556V24.3224V34.9795C50 37.8029 47.7105 40.0924 44.8871 40.0924H5.11294C2.28953 40.0924 0 37.8029 0 34.9795V24.3121V11.7556C0 9.10678 2.14579 6.96099 4.79466 6.96099H14.384L14.8357 5.05133C15.5236 2.09446 18.1622 0 21.2012 0H28.809C31.848 0 34.4867 2.09446 35.1745 5.05133L35.616 6.96099H45.2053ZM10 13.8809C10 12.5565 8.92197 11.4784 7.59754 11.4784C6.26283 11.4784 5.1848 12.5565 5.1848 13.8809C5.1848 15.2053 6.26283 16.2834 7.58727 16.2834C8.92197 16.2936 10 15.2156 10 13.8809ZM36.8275 23.5832C36.8275 17.0534 31.5298 11.7556 25 11.7556C18.4702 11.7556 13.1725 17.0534 13.1725 23.5832C13.1725 30.1129 18.4702 35.4107 25 35.4107C31.5298 35.4107 36.8275 30.1129 36.8275 23.5832Z" fill="#8592A6" />
                  </svg>
                  <span>1 / 20</span>
                </div>
                <div className="right-upload">
                  {/* <div className="img-upoaded">
                    <img src="https://pictures.tinyaway.com/filters:format(jpg)/405x405/Listings/Images/2024/05/1/gwcisxhbjhxgshvrlxbf1714967317336.jpg" />
                  </div>  */}
                </div>
              </div>
            </div>
            <div className="flex flex-direction-column gap-3 mt-5 title-group">
              <label>ADD A TITLE (OPTIONAL)</label>
              <input className="" type="text" />
            </div>
            <div className="flex flex-direction-column gap-3 mt-5 title-group">
              <label>TELL US ABOUT YOUR TRIP</label>
              <div className="textarea-text-up">
                <span>Write 100 words for a chance to earn a <a href="">Feature Tag</a></span>
                <textarea>
                </textarea>
              </div>
            </div>
            <div className="flex flex-direction-column gap-3 mt-5 title-group">
              <label>ADD LOCATION</label>
              <div className="search-box">
                <i className="la la-search"></i>
                <input className="search" type="text" />
              </div>
            </div>
            <div className="flex flex-direction-column gap-3 mt-5 title-group">
              <label>ADD TO TOPICS (OPTIONAL)</label>
              <div className="group-btn-serach">
                <a href="">#TinyHouse</a>
                <a href="">#TinyHouse</a>
                <a href="">#TinyHouse</a>
                <a href="">#TinyHouse</a>
                <a href="">#TinyHouse</a>
                <a href="">#TinyHouse</a>
                <a href="">#TinyHouse</a>
              </div>
            </div>
            <div className="flex flex-direction-column gap-3 mt-1 title-group">
              <div className="search-box">
                <i className="la la-search"></i>
                <input className="search" type="text" />
              </div>
            </div>
            <div className="flex gap-3 items-center justify-center mb-5">
              <input type="checkbox" />
              By uploading these photos, I confirm that they belong to me and that I agree to Tinyawayy.com's Terms & Conditions and Community Rules
            </div>
            <ButtonPrimary className="w-250-px">SUBMIT</ButtonPrimary>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="bgcolor-light pb-14 pt-10">
      <div className="container">
        <div className="row-profile  mt-5 mb-5">
          {PagePeferralProgram()}
          <div className="left-user-details flex-wrap h-1/2">
            <div className="creatstory-card-right">
              <h4>How Was Your Experience?</h4>
              <div className="card-img-points">
                Share your thoughts and earn up to 80 Points
              </div>
              <div className="step step-wrapper start mt-10 fill-1">
                <div className="step-line "></div>
                <div className="step-icon">★</div>
                <div className="step-content">
                  <div className="title">Get started</div>
                  <div>
                    <div className="subtitle">Prepare a review</div>
                    <div className="desc">
                      Prepare the experience and write at least 50 characters of your feedback.
                    </div>
                  </div>
                  <div>
                    <div className="points">0 / 80 Pointes earned</div>
                    <div className="note">
                      You will get respective points after we check your content.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PageCreateStory;
